<template>
	<v-menu
		:modelValue="modelValue"
		open-on-click
		:close-on-content-click="false"
		@update:modelValue="$emit('update:modelValue', $event)"
	>
		<!-- location="bottom" -->
		<!-- :location-strategy="handlePositioning" -->
		<template v-slot:activator="{ props, isActive }">
			<slot
				name="activator"
				v-bind="{ props, isActive }"
			>
				<ao-icon
					v-bind="props"
					iconName="info"
					class="text-primary ml-1 cursor-pointer"
				/>
			</slot>
		</template>

		<v-card
			:class="$style.card"
			class="pa-4"
			:width="getWidth"
		>
			<v-progress-circular
				v-if="loading"
				indeterminate
				size="24"
				color="primary"
			/>
			<div v-else class="overflow-x-hidden">
				<slot :setWidth="setWidth"/>
				<ao-icon
					:class="$style.close"
					iconName="close"
					class="position-absolute cursor-pointer"
					@click="handleClose"
				/>
			</div>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	name: 'PopupWrapper',

	props: {
		modelValue: {
			type: Boolean,
			default: true,
		},
		width: {
			type: String,
			default: '',
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		getWidth() {
			if(this.width){
				return this.width
			}
			if(this.localWidth){
				return this.localWidth
			}
			return 300
		},
	},

	data() {
		return {
			localWidth: 0,
		}
	},

	methods: {
		handlePositioning(data) {
			this.$nextTick(() => {
				const content = data.contentEl._value
				const activator = data.activatorEl._value

				const activatorRect = activator.getBoundingClientRect()
				const contentRect = content.getBoundingClientRect()
				const width = window.innerWidth
				const height = window.innerHeight

				content.style.left = activatorRect.left + 'px'
				content.style.top = activatorRect.top + activatorRect.height + 'px'

				if (width - activatorRect.x <= contentRect.width) {
					content.style.left = activatorRect.left - contentRect.width + activatorRect.width + 'px'
				}
				if (height - activatorRect.y <= contentRect.height) {
					content.style.top = activatorRect.top - contentRect.height + 'px'
				}
			})
		},
		setWidth(width) {
			this.localWidth = width
		},
		handleClose() {
			this.$emit('update:modelValue', false)
		}
	},
}
</script>

<style module lang="scss">
.card {
	.close {
		position: absolute;
		right: 8px;
		top: 8px;

		color: #86919d;
		font-size: 12px;
	}
}
</style>
